import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { DigitalTwin } from 'types/dt-graphql-apollo-v2';
import { ROUTE_DIGITAL_TWIN } from 'utils/router-url';
import { useFeatureFlag, FeatureFlags } from 'utils/feature-flags';
import { EmptyTemplate } from 'pages/EmptyTemplate/EmptyTemplate';
import {
  Schemas,
  ViewSchemaPage,
  DataQualityExplorer,
  ViewCollectionReportPage,
  ViewConsistencyReportPage,
  ViewConsistencyRuleReportPage,
  DataConsistency,
} from '.';

/** Component that handles the routing for a single Project (DigitalTwin) */
export const DigitalTwinView = ({
  digitalTwin,
}: {
  digitalTwin: DigitalTwin;
}) => {
  const enabledDataQualityExplorer = useFeatureFlag(
    FeatureFlags.enabledDataQualityExplorer
  );
  const enabledDataConsistency = useFeatureFlag(
    FeatureFlags.enabledDataConsistency
  );

  return (
    <Switch>
      {/* Landing page */}
      <Route exact path={ROUTE_DIGITAL_TWIN}>
        <Schemas digitalTwin={digitalTwin} />
      </Route>

      {/* Schema pages */}
      <Route exact path={`${ROUTE_DIGITAL_TWIN}/schemas`}>
        <Schemas digitalTwin={digitalTwin} />
      </Route>
      <Route path={`${ROUTE_DIGITAL_TWIN}/schemas/:schemaNameDT?`}>
        <ViewSchemaPage digitalTwin={digitalTwin} />
      </Route>

      {/* Data Quality Explorer */}
      <Route exact path={`${ROUTE_DIGITAL_TWIN}/data-quality`}>
        {enabledDataQualityExplorer ? (
          <DataQualityExplorer digitalTwin={digitalTwin} />
        ) : (
          <EmptyTemplate
            title="Page Not Found"
            description="Couldn't find the page you are looking for."
            graphic="EmptyStateSearch"
          />
        )}
      </Route>
      {/* Data Consistency Explorer */}
      <Route exact path={`${ROUTE_DIGITAL_TWIN}/data-consistency`}>
        {enabledDataConsistency ? (
          <DataConsistency digitalTwin={digitalTwin} />
        ) : (
          <EmptyTemplate
            title="Page Not Found"
            description="Couldn't find the page you are looking for."
            graphic="EmptyStateSearch"
          />
        )}
      </Route>

      {/* Consistency Rule detail (must be before the parent consistency report route) */}
      <Route
        exact
        path={`${ROUTE_DIGITAL_TWIN}/data-quality/consistency/:consistencyReportId/rule/:ruleId`}
      >
        {enabledDataQualityExplorer ? (
          <ViewConsistencyRuleReportPage />
        ) : (
          <EmptyTemplate
            title="Page Not Found"
            description="Couldn't find the page you are looking for."
            graphic="EmptyStateSearch"
          />
        )}
      </Route>

      {/* Consistency Report detail (must be before the generic :collectionReportId) */}
      <Route
        exact
        path={`${ROUTE_DIGITAL_TWIN}/data-quality/consistency/:consistencyReportId`}
      >
        {enabledDataQualityExplorer ? (
          <ViewConsistencyReportPage />
        ) : (
          <EmptyTemplate
            title="Page Not Found"
            description="Couldn't find the page you are looking for."
            graphic="EmptyStateSearch"
          />
        )}
      </Route>

      <Route
        exact
        path={`${ROUTE_DIGITAL_TWIN}/data-quality/:collectionReportId`}
      >
        {enabledDataQualityExplorer ? (
          <ViewCollectionReportPage />
        ) : (
          <EmptyTemplate
            title="Page Not Found"
            description="Couldn't find the page you are looking for."
            graphic="EmptyStateSearch"
          />
        )}
      </Route>
    </Switch>
  );
};
